<template>
<div>
    <edit-profile-form> </edit-profile-form>
</div>
</template>

<script>
import EditProfileForm from '@/components/App/account/ProfileForm.vue';

export default {
    components: {
        EditProfileForm
    }
};
</script>

<style></style>
